import { createTheme, Theme, ThemeOptions } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";
import { leoneckThemeConfig } from "./leoneck-theme";
import { staykoookThemeConfig } from "./staykoook-theme";
import { flemlodgeThemeConfig } from "./flemlodge-theme";
import { amarisThemeConfig } from "./amaris-theme";
import { likemagicThemeConfig } from "./likemagic-theme";
import { anstattThemeConfig } from "./anstatt-theme";
import { guesthouseZurzachThemeConfig } from "./guesthouse-zurzach-theme";
import { urbmThemeConfig } from "./urbm-theme";
import { walhallaThemeConfig } from "./walhalla-theme";
import { likemagicBackofficeThemeConfig } from "./likemagic-backoffice-theme";
import { mmntThemeConfig } from "./mmnt-theme";
import { contiThemeConfig } from "./conti-theme";
import { smartHotelThemeConfig } from "./smarthotel-theme";
import { stayBrightThemeConfig } from "./stay-bright-theme";
import { welcomeHomesThemeConfig } from "./welcome-homes-theme";
import { fredHotelsThemeConfig } from "./fredhotels-theme";
import { schaniBioThemeConfig } from "./schani-bio-theme";
import { rivaThemeConfig } from "./riva-theme";
import { princessThemeConfig } from "./princess-theme";
import { pensionarosaThemeConfig } from "./pensionarosa-theme";
import { zipperThemeConfig } from "./zipper-theme";
import { gghotelThemeConfig } from "./gghotel-theme";
import { zzzpaceThemeConfig } from "./zzzpace-theme";
import { nshotelThemeConfig } from "./nshotel-theme";
import { flatlightThemeConfig } from "./flatlight-theme";
import { tfePocThemeConfig } from "./tfe-poc-theme";
import { achesahomesThemeConfig } from "./achesahomes-theme";
import { ibisStylesThemeConfig } from "./ibis-styles-theme";
import { pkfThemeConfig } from "./pkf-theme";
import { schaniSalonThemeConfig } from "./schani-salon-theme";
import { schaniGeneralThemeConfig } from "./schani-general-theme";
import { mcdreamsThemeConfig } from "./mcdreams-theme";
import { yarnThemeConfig } from "./yarn-theme";
import { dreamcationThemeConfig } from "./dreamcation-theme";
import { schaniUnoThemeConfig } from "./schani-uno-theme";
import { regiohotelThemeConfig } from "./regiohotel-theme";
import { aByAdinaThemeConfig } from "./a-by-adina-theme";
import { hotelswissstarThemeConfig } from "./hotelswissstar-theme";
import { lifehomeThemeConfig } from "./lifehome-theme";
import { hopfenhotelThemeConfig } from "./hopfenhotel-theme";
import { urbanislandThemeConfig } from "./urbanisland-theme";
import { suite4meThemeConfig } from "./suite4me-theme";
import { staeyThemeConfig } from "./staey-theme";
import { hotelamkreiselThemeConfig } from "./hotelamkreisel-theme";
import { hotelviennaThemeConfig } from "./hotelvienna-theme";
import { lofthotelThemeConfig } from "./lofthotel-theme";
import { phagenbeckThemeConfig } from "./phagenbeck-theme";
import { stayawesomeThemeConfig } from "./stayawesome-theme";
import { aparthoteladelbodenThemeConfig } from "./aparthoteladelboden-theme";
import { ilmomentoThemeConfig } from "./ilmomento-theme";
import { peakstayThemeConfig } from "./peakstay-theme";
import { bunkHotelThemeConfig } from "./bunk-hotel-theme";
import { bSmartsThemeConfig } from "./b-smarts-theme";
import { bohnThemeConfig } from "./bohn-theme";
import { bergidyllThemeConfig } from "./bergidyll-theme";
//ADD here import

export { staykoookThemeConfig } from "./staykoook-theme";

export const THEMES = {
  STAYKOOOK_THEME: "staykooook-theme",
  LEONECK_THEME: "leoneck-theme",
  FLEM_LODGE_THEME: "flemlodge-theme",
  AMARIS_THEME: "amaris-theme",
  ANSTATT_THEME: "anstatt-theme",
  LIKE_MAGIC_THEME: "likemagic-theme",
  GUESTHOUSE_ZURZACH_THEME: "guesthouse-zurzach-theme",
  URBM_THEME: "urbm-theme",
  WALHALLA_THEME: "walhalla-theme",
  LIKE_MAGIC_BACKOFFICE_THEME: "likemagic-backoffice-theme",
  MMNT_THEME: "mmnt-theme",
  CONTI_THEME: "conti-theme",
  SMARTHOTEL_THEME: "smarthotel-theme",
  STAYBRIGHT_THEME: "staybright-theme",
  WELCOME_HOMES_THEME: "welcome-homes-theme",
  FREDHOTELS_THEME: "fredhotels-theme",
  SCHANI_GENERAL_THEME: "schani-general-theme",
  SCHANI_BIO_THEME: "schani-bio-theme",
  SCHANI_SALON_THEME: "schani-salon-theme",
  SCHANI_UNO_THEME: "schani-uno-theme",
  RIVA_THEME: "riva-theme",
  PRINCESS_THEME: "princess-theme",
  PENSIONAROSA_THEME: "pensionarosa-theme",
  ZIPPER_THEME: "zipper-theme",
  GGHOTEL_THEME: "gghotel-theme",
  ZZZPACE_THEME: "zzzpace-theme",
  NSHOTEL_THEME: "nshotel-theme",
  FLATLIGHT_THEME: "flatlight-theme",
  TFE_POC_THEME: "tfe-poc-theme",
  ACHESAHOMES_THEME: "achesahomes-theme",
  IBIS_STYLES_THEME: "ibis-styles-theme",
  PKF_THEME: "pkf-theme",
  MCDREAMS_THEME: "mcdreams-theme",
  YARN_THEME: "yarn-theme",
  DREAMCATION_THEME: "dreamcation-theme",
  REGIOHOTEL_THEME: "regiohotel-theme",
  A_BY_ADINA_THEME: "a-by-adina-theme",
  HOTELSWISSSTAR_THEME: "hotelswissstar-theme",
  LIFEHOME_THEME: "lifehome-theme",
  HOPFENHOTEL_THEME: "hopfenhotel-theme",
  URBANISLAND_THEME: "urbanisland-theme",
  SUITE4ME_THEME: "suite4me-theme",
  STAEY_THEME: "staey-theme",
  HOTELAMKREISEL_THEME: "hotelamkreisel-theme",
  HOTELVIENNA_THEME: "hotelvienna-theme",
  LOFTHOTEL_THEME: "lofthotel-theme",
  PHAGENBECK_THEME: "phagenbeck-theme",
  STAYAWESOME_THEME: "stayawesome-theme",
  APARTHOTELADELBODEN_THEME: "aparthoteladelboden-theme",
  ILMOMENTO_THEME: "ilmomento-theme",
  PEAKSTAY_THEME: "peakstay-theme",
  BUNK_HOTEL_THEME: "bunk-hotel-theme",
  B_SMARTS_THEME: "b-smarts-theme",
  BOHN_THEME: "bohn-theme",
  BERGIDYLL_THEME: "bergidyll-theme"
  //ADD here theme enum
};

export const themesOptions: Record<string, ThemeOptions> = {
  [THEMES.STAYKOOOK_THEME]: staykoookThemeConfig,
  [THEMES.LEONECK_THEME]: leoneckThemeConfig,
  [THEMES.FLEM_LODGE_THEME]: flemlodgeThemeConfig,
  [THEMES.AMARIS_THEME]: amarisThemeConfig,
  [THEMES.ANSTATT_THEME]: anstattThemeConfig,
  [THEMES.LIKE_MAGIC_THEME]: likemagicThemeConfig,
  [THEMES.GUESTHOUSE_ZURZACH_THEME]: guesthouseZurzachThemeConfig,
  [THEMES.URBM_THEME]: urbmThemeConfig,
  [THEMES.WALHALLA_THEME]: walhallaThemeConfig,
  [THEMES.LIKE_MAGIC_BACKOFFICE_THEME]: likemagicBackofficeThemeConfig,
  [THEMES.MMNT_THEME]: mmntThemeConfig,
  [THEMES.CONTI_THEME]: contiThemeConfig,
  [THEMES.SMARTHOTEL_THEME]: smartHotelThemeConfig,
  [THEMES.STAYBRIGHT_THEME]: stayBrightThemeConfig,
  [THEMES.WELCOME_HOMES_THEME]: welcomeHomesThemeConfig,
  [THEMES.FREDHOTELS_THEME]: fredHotelsThemeConfig,
  [THEMES.SCHANI_BIO_THEME]: schaniBioThemeConfig,
  [THEMES.SCHANI_GENERAL_THEME]: schaniGeneralThemeConfig,
  [THEMES.SCHANI_SALON_THEME]: schaniSalonThemeConfig,
  [THEMES.SCHANI_UNO_THEME]: schaniUnoThemeConfig,
  [THEMES.RIVA_THEME]: rivaThemeConfig,
  [THEMES.PRINCESS_THEME]: princessThemeConfig,
  [THEMES.PENSIONAROSA_THEME]: pensionarosaThemeConfig,
  [THEMES.ZIPPER_THEME]: zipperThemeConfig,
  [THEMES.GGHOTEL_THEME]: gghotelThemeConfig,
  [THEMES.ZZZPACE_THEME]: zzzpaceThemeConfig,
  [THEMES.NSHOTEL_THEME]: nshotelThemeConfig,
  [THEMES.FLATLIGHT_THEME]: flatlightThemeConfig,
  [THEMES.TFE_POC_THEME]: tfePocThemeConfig,
  [THEMES.ACHESAHOMES_THEME]: achesahomesThemeConfig,
  [THEMES.IBIS_STYLES_THEME]: ibisStylesThemeConfig,
  [THEMES.PKF_THEME]: pkfThemeConfig,
  [THEMES.MCDREAMS_THEME]: mcdreamsThemeConfig,
  [THEMES.YARN_THEME]: yarnThemeConfig,
  [THEMES.DREAMCATION_THEME]: dreamcationThemeConfig,
  [THEMES.REGIOHOTEL_THEME]: regiohotelThemeConfig,
  [THEMES.A_BY_ADINA_THEME]: aByAdinaThemeConfig,
  [THEMES.HOTELSWISSSTAR_THEME]: hotelswissstarThemeConfig,
  [THEMES.LIFEHOME_THEME]: lifehomeThemeConfig,
  [THEMES.HOPFENHOTEL_THEME]: hopfenhotelThemeConfig,
  [THEMES.URBANISLAND_THEME]: urbanislandThemeConfig,
  [THEMES.SUITE4ME_THEME]: suite4meThemeConfig,
  [THEMES.STAEY_THEME]: staeyThemeConfig,
  [THEMES.HOTELAMKREISEL_THEME]: hotelamkreiselThemeConfig,
  [THEMES.HOTELVIENNA_THEME]: hotelviennaThemeConfig,
  [THEMES.LOFTHOTEL_THEME]: lofthotelThemeConfig,
  [THEMES.PHAGENBECK_THEME]: phagenbeckThemeConfig,
  [THEMES.STAYAWESOME_THEME]: stayawesomeThemeConfig,
  [THEMES.APARTHOTELADELBODEN_THEME]: aparthoteladelbodenThemeConfig,
  [THEMES.ILMOMENTO_THEME]: ilmomentoThemeConfig,
  [THEMES.PEAKSTAY_THEME]: peakstayThemeConfig,
  [THEMES.BUNK_HOTEL_THEME]: bunkHotelThemeConfig,
  [THEMES.B_SMARTS_THEME]: bSmartsThemeConfig,
  [THEMES.BOHN_THEME]: bohnThemeConfig,
  [THEMES.BERGIDYLL_THEME]: bergidyllThemeConfig
  //ADD here theme mapping
};

export const createTenantTheme = (themeName: string, overrideTheme?: ThemeOptions): Theme => {
  let themeOptions = themesOptions[themeName];

  if (!themeOptions) {
    console.warn(new Error(`The theme ${themeName} is not valid`));
    themeOptions = themesOptions[THEMES.LIKE_MAGIC_THEME];
  }

  return createTheme(overrideTheme ? deepmerge(themeOptions, overrideTheme) : themeOptions);
};
